export enum SponsorLevel {
  PLATINUM = 'PLATINUM',

  GOLD = 'GOLD',

  SILVER = 'SILVER',

  BRONZE = 'BRONZE',
}
